import { v4 as uuidv4 } from "uuid";
import React, { useState, useCallback, useMemo } from "react";

import { ChatMessage } from "./types/types";

import Input from "./components/InputContainer";
import Navigation from "./components/Navigation";
import ChatResponseContainer from "./components/ChatResponseContainer";

import CX from "./images/cx.png";

const App: React.FC = () => {
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const sessionId = useMemo(() => uuidv4(), []);
  /* ---------------- SEND MESSAGE ---------------- */
  const sendMessage = useCallback(async () => {
    if (!input.trim()) return;

    const userMessage = input.trim();
    setMessages((prev) => [...prev, { sender: "user", text: userMessage }]);
    setInput("");
    setIsLoading(true);

    try {
      const res = await fetch(
        "https://6g3wrobd54.execute-api.us-east-1.amazonaws.com/live",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ userInput: userMessage, sessionId }),
        },
      );

      const { botResponse, buttons } = await res.json();

      if (botResponse) {
        setMessages((prev) => [
          ...prev,
          { sender: "bot", text: botResponse, buttons },
        ]);
      }
    } catch (err) {
      console.error("Send error:", err);
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "Something went wrong." },
      ]);
    } finally {
      setIsLoading(false);
    }
  }, [input, sessionId]);

  /* ---------------- QUICK REPLY ---------------- */
  const handleQuickReply = useCallback(
    async (text: string) => {
      if (!text.trim()) return;

      setMessages((prev) => [...prev, { sender: "user", text }]);
      setIsLoading(true);

      try {
        const res = await fetch(
          "https://6g3wrobd54.execute-api.us-east-1.amazonaws.com/live",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ userInput: text, sessionId }),
          },
        );

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const { botResponse, buttons } = await res.json();

        if (botResponse) {
          setMessages((prev) => [
            ...prev,
            { sender: "bot", text: botResponse, buttons },
          ]);
        }
      } catch (err) {
        console.error("Quick reply error:", err);
      } finally {
        setIsLoading(false);
      }
    },
    [sessionId],
  );

  return (
    <div className="main">
      <div className="outer">
        <div className="cx-img-container">
          <img src={CX} alt="CX" className="cx-img" />
        </div>

        <div className="container">
          <Navigation />
          <ChatResponseContainer
            messages={messages}
            isLoading={isLoading}
            onQuickReply={handleQuickReply}
          />
          <Input
            input={input}
            setInput={setInput}
            sendMessage={sendMessage}
            isLoading={isLoading}
            maxLength={1024}
          />
        </div>
      </div>
    </div>
  );
};

export default App;
